<template>
<el-dialog :visible.sync="dialogVisible" :before-close="closeModal" width="650px">
    <div class="w-100 text-center mt-5">
        <Success border_color="#CAEDE7" stroke_width="1.2" size="45" />
        <h3 class="c-ndarkthree bold mb-2 mt-1">
            Sua solicitação está em análise!
        </h3>
        <p class="c-ndarkfour regular">
            Nossa equipe irá analisar sua solicitação de financiamento de {{ financingTypeText }}<br>
            e vamos elaborar uma proposta perfeita para sua empresa.<br>
            Aguarde por nosso contato em até 48h!
        </p>
    </div>
    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">       
        <router-link to="" @click.native="handleHelpButton"  :class="`${getPrimaryColor} mr-4 c-ndarkfour`">
            Cancelar
        </router-link>
        <Button @click="closeModal" :color="getPrimaryColor">
            Ok!
        </Button>
    </span>    
</el-dialog>
</template>

<script>
import Success from '@/components/icons/Success.vue'
export default {
    components: {
        Success
    },
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false
        },
        financingTypeText: {
            default: 'contratos e projetos'
        }
    },
    data() {
        return {

        }
    },
    methods: {
        closeModal() {
            this.$emit('closeModal', false)
        },
        handleHelpButton() {
            this.$emit('helpModal')
        }
    }
}
</script>

<style>

</style>
